import * as React from "react";
import type { SVGProps } from "react";

interface YellowRedCardProps extends SVGProps<SVGSVGElement> {
  cancelled?: boolean;
}
const YellowRedCard = ({ cancelled = false, ...props }: YellowRedCardProps) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" {...props}>
    <g>
    <g fill="none" fillRule="evenodd" transform="translate(5 3)">
      <path
        stroke="#FFF"
        strokeWidth={1.75}
        d="M9-.88A1.87 1.87 0 0 1 10.88 1v2.13H14A1.87 1.87 0 0 1 15.88 5v12A1.87 1.87 0 0 1 14 18.88H6A1.87 1.87 0 0 1 4.12 17v-2.13H1A1.87 1.87 0 0 1-.88 13V1A1.87 1.87 0 0 1 1-.88Z"
      />
      <rect
        width={11}
        height={15}
        x={-0.5}
        y={-0.5}
        fill="#FFE42B"
        stroke="#000"
        rx={1}
      />
      <rect
        width={11}
        height={15}
        x={4.5}
        y={3.5}
        fill="#FF1212"
        stroke="#000"
        rx={1}
      />
    </g>
        {cancelled && (
        <rect
          width="25"
          height="2.5"
          x="-.494"
          y="10.746"
          fill="#000"
          fillRule="evenodd"
          stroke="#FFF"
          rx="1"
          transform="rotate(-45 12.006 11.996)"
        />
      )}
    </g>
  </svg>
);
export default YellowRedCard;
